import { type ReactNode } from 'react';

import { PathField } from './PathField';

interface HunterSurfaceProps {
  children: ReactNode;
  className?: string;
}

export function HunterSurface({ children, className }: HunterSurfaceProps) {
  return (
    <section className={`relative overflow-hidden rounded-[var(--radius-lg)] border border-border bg-[var(--bg-base)] ${className ?? ''}`}>
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <PathField />
      </div>
      <div className="relative z-10 p-5 sm:p-6">{children}</div>
    </section>
  );
}
